import React, { FC } from 'react';
import { PostStatus } from '../../../data-layer/posts/constants';
import { PostsGridContent } from '../PostsGridContent/PostsGridContent';
import { usePostCollection } from '../usePostCollection';
import { PER_PAGE } from './constants';
import { BusinessPostsGridProps } from './types';

export const BusinessPostsGrid: FC<BusinessPostsGridProps> = ({ fromBusinessId, ...props }) => {
    const collection = usePostCollection({
        namespace: `business-overview-${fromBusinessId}`,
        filters: {
            statuses: [PostStatus.PUBLISHED, PostStatus.LIMITED],
            businessId: fromBusinessId,
            collectionId: undefined,
            amount: PER_PAGE,
        },
        forceFiltersUpdate: true,
    });

    return (
        <PostsGridContent
            collection={collection}
            keyPrefix={`business-${fromBusinessId}`}
            {...props}
        />
    );
};
